__turbopack_export_value__({
  "className": "className__font_7dddc211__59c98e43",
});
